exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.view-more-categ{\n  font-size: 21px;\n}\n", ""]);

// exports
